export const CHECK_STATUS = {
  PASS: 'pass',
  FAIL: 'fail',
  SKIPPED: 'skipped',
};

export const createEmptyReachability = () => ({
  portal: CHECK_STATUS.SKIPPED,
  api: CHECK_STATUS.SKIPPED,
  wss: CHECK_STATUS.SKIPPED,
  oauth: CHECK_STATUS.SKIPPED,
});

export const createEmptyWebrtc = () => ({
  supported: false,
  hostCandidates: 0,
  srflxCandidates: 0,
  relayCandidates: 0,
  udp: false,
  tcp: false,
  tlsRelay: false,
  relayProtocols: [],
  error: null,
});

export const createEmptyVideoCall = () => ({
  udp: { status: CHECK_STATUS.SKIPPED, feedback: null },
  tcp: { status: CHECK_STATUS.SKIPPED, feedback: null },
  step: null,
  reason: null,
  meetingId: null,
  mediaRegion: null,
  eventDeleted: null,
  cleanupErrors: [],
});

export const createEmptyReport = () => ({
  reportId: null,
  generatedAt: null,
  reachability: createEmptyReachability(),
  videoCall: createEmptyVideoCall(),
  webrtc: createEmptyWebrtc(),
  chimeReadiness: null,
  verdict: {
    verdict: 'NOT_TESTED',
    label: 'Not tested',
    message: 'Run the network test to check calling readiness.',
    primaryCause: null,
    recommendation: null,
  },
});
